import { render } from "./InventoryBrandsReports.vue?vue&type=template&id=f8d4d5d4&ts=true"
import script from "./InventoryBrandsReports.vue?vue&type=script&lang=ts"
export * from "./InventoryBrandsReports.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__